export default {
  prevText: 'Prev',
  nextText: 'Next'
}



// WEBPACK FOOTER //
// ./src/components/pagination/locale/en_US.js